// extracted by mini-css-extract-plugin
module.exports = {"DemoWrapper":"demographics_DemoWrapper__iKgHz","statHolder":"demographics_statHolder__E5JPV","stat":"demographics_stat__JwllL","preWrap":"demographics_preWrap__2h38M"};